// import styled from "@mui/material/styles/styled";
import { styled } from "@mui/material/styles";

const SectionStyled = styled("section")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  background: "white",
}));

export default SectionStyled;
